<template>
  <div class="indexs1">
    <div class="top">
      <van-nav-bar left-text="返回" right-text="更多" left-arrow @click-left="onClickLeft" />
    </div>
    <div class="swi1">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item>
          <img :src="swi.img1" alt />
        </van-swipe-item>
        <van-swipe-item>
          <img :src="swi.img2" alt />
        </van-swipe-item>
        <van-swipe-item>
          <img :src="swi.img3" alt />
        </van-swipe-item>
        <van-swipe-item>
          <img :src="swi.img4" alt />
        </van-swipe-item>
      </van-swipe>
    </div>
    <img
      class="i"
      src="https://img10.360buyimg.com/umm/jfs/t1/186802/9/666/59158/608ab254E8e12c7a3/06d80ae8042f1a34.png"
      alt
    />
    <!-- 价格描述================== -->
    <div class="jg">
      <div class="jg_up">
        <div class="jg_up1">
          <span>
            <em>￥</em>
            <em class="e2">5199</em>.00
          </span>
        </div>
        <div class="jg_up2">￥5299.00</div>
        <div class="jg_up3">
          <div>
            <span class="iconfont iconmoney"></span>降价提醒
          </div>
          <div>
            <span class="iconfont iconshoucang animated" @click="text()" :class="{activ:re}"></span> 收藏
          </div>
        </div>
      </div>
      <div class="jg_conter">
        <span></span>
        Apple iPhone 11 (A2223) 128GB 黄色 移动联通电信4G手机 双卡双待
      </div>
      <div class="jg_below">仅加99得价值149元原厂快充头，仅加799元得价值1246元AirPods蓝牙耳机！更多优惠！</div>
    </div>
    <!-- 领券描述=================== -->
    <div class="bgc">
      <div class="item_floor">
        <p class="p1">
          <span>优惠</span>
          <span>满31减30</span>
          <span>满30减10</span>
          <span>满4000减400</span>
        </p>
        <p class="p2">
          <span>赠品</span>
          <span>购买立享4件赠品（赠完即止）</span>
        </p>
        <p class="p2">
          <span>满额返券</span>
          <span>满10元减2元运动鞋优惠券</span>
        </p>
        <p class="p2">
          <span>免费领</span>
          <span>体验卡免费领取，超大流量任性用</span>
        </p>
        <!-- {$store.state.empty{}} -->
        <div class="d1">
          <span>白条</span>
          <span>12期免息任性用！</span>
        </div>
      </div>
    </div>
    <!-- 问答========================================= -->
    <div class="wd">
      <div class="wd_box">
        <div class="wd_box_up">
          <div>问答</div>
          <a
            href="https://qa.m.jd.com/faqs/index.html?sceneval=2&ptag=7001.1.124&productId=100004770263&ispg=&_fd=jdm&jxsid=16226436956661338358"
          >
            查看全部回答
            <van-icon name="arrow" />
          </a>
        </div>
        <div class="wd_box_conter">
          <span class="s1">问</span>
          <span class="s2">最近购买iphone11的果友们 请问一下手机里包含充电器和耳机有嘛 麻烦告知一下呦 谢谢啦</span>
          <span class="s3">共227个回答</span>
        </div>
        <div class="wd_box_below">
          <span class="s1">问</span>
          <span class="s2">你们128GB多少钱买的</span>
          <span class="s3">共170个回答</span>
        </div>
      </div>
    </div>
    <nav class="nav">
      <van-tabs sticky swipeable>
        <van-tab title="商品介绍" name="a">
          <div class="d1"></div>
          <div class="dd">
            <span ref="im1" id="span" :class="lem" @click="playPause()"></span>
            <img
              ref="im"
              id="img"
              src="https://img.300hu.com/4c1f7a6atransbjngwcloud1oss/4f9747cd241241042224418817/imageSampleSnapshot/1572252477_309492659.100_5508.jpg"
              alt
            />
            <video id="video1" width="100%" controls="true">
              <source
                src="https://vod.300hu.com/4c1f7a6atransbjngwcloud1oss/4f9747cd241241042224418817/v.f20.mp4?dockingId=ab3e8bc9-64a0-4a5d-84b4-335aa34928cb&storageSource=3"
                type="video/mp4"
              />
            </video>
          </div>
          <div class="imgg">
            <img src="~@/assets/images/img1.png" alt />
            <img src="~@/assets/images/img2.png" alt />
            <img src="~@/assets/images/img3.png" alt />
            <img src="~@/assets/images/img4.png" alt />
            <img src="~@/assets/images/img5.png" alt />
            <img src="~@/assets/images/img6.png" alt />
            <div>
              <img src="~@/assets/images/jdon.png" alt />
            </div>
          </div>
        </van-tab>
        <van-tab title="规格参数" name="b">
          <div class="imgg">
            <img src="~@/assets/images/cs1.png" alt />
            <img src="~@/assets/images/cs2.png" alt />
            <img src="~@/assets/images/cs3.png" alt />
            <img src="~@/assets/images/4.png" alt />
            <div>
              <img src="~@/assets/images/jdon.png" alt />
            </div>
          </div>
        </van-tab>
        <van-tab title="售后保障" name="c">
          <div class="imgg">
            <img src="~@/assets/images/cs4.png" alt />
            <img src="~@/assets/images/cs5.png" alt />
            <div>
              <img src="~@/assets/images/jdon.png" alt />
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </nav>
    <!-- 底部按钮模块================================================= -->
    <div class="footer">
      <van-goods-action>
        <van-goods-action-icon icon="chat-o" text="客服" color="#ee0a24" @click="no()" />
        <van-goods-action-icon icon="cart-o" text="购物车" :badge="num" @click="tab4()" />
        <van-goods-action-icon
          icon="star"
          :text="te"
          :icon-class="{ active: isshow }"
          @click=" text()"
        />
        <van-goods-action-button type="warning" text="加入购物车" @click="s()" />
        <van-goods-action-button type="danger" text="立即购买" @click="s()" />
      </van-goods-action>
    </div>
    <div id="tc">
      <van-sku
        v-model="show"
        :sku="sku"
        :goods="goods"
        @add-cart="onAddCartClicked"
        @buy-clicked="onBuyClicked"
      />
    </div>
    <div id="dibu"></div>
  </div>
</template>
<script>
// import index from "@/views/index.vue";
import data from "@/data/indexs/indexs1.js";
export default {
  components: {
    // 组件注册
    // index
  },
  data() {
    return {
      kon: null,
      lem: null,
      num: null,
      ispulse: false,
      isshow: false,
      te: "收藏",
      swi: data.data.swi,
      re: false,
      // 商品规格==========================
      show: false,
      sku: {
        // 数据结构见下方文档
        // 所有sku规格类目与其值的从属关系，比如商品有颜色和尺码两大类规格，颜色下面又有红色和蓝色两个规格值。
        // 可以理解为一个商品可以有多个规格类目，一个规格类目下可以有多个规格值。
        tree: [
          {
            k: "颜色",
            k_s: "s1",
            k_id: "1",
            // count: 2
            v: [
              {
                id: "白色",
                name: "白色",
                imgUrl:
                  "//m.360buyimg.com/mobilecms/s1265x1265_jfs/t1/181147/16/6648/192505/60b4db17E96972480/b658977c7b38fb68.jpg!q70.dpg.webp"
              },
              {
                id: "黑色",
                name: "黑色",
                imgUrl:
                  "//m.360buyimg.com/mobilecms/s1265x1265_jfs/t1/148614/3/19332/194556/60b4daf6E6a82e433/b377ed29fe81969d.jpg!q70.dpg.webp"
              },
              {
                id: "红色",
                name: "红色",
                imgUrl:
                  "//m.360buyimg.com/mobilecms/s1265x1265_jfs/t1/178142/29/6740/223672/60b4db50Eaa2760ac/e8329fb598d24e82.jpg!q70.dpg.webp"
              },
              {
                id: "紫色",
                name: "紫色",
                imgUrl:
                  "//m.360buyimg.com/mobilecms/s1265x1265_jfs/t1/129466/10/19818/214901/60b4dbaeEc1be2431/5ab2057eb1162430.jpg!q70.dpg.webp"
              },
              {
                id: "黄色",
                name: "黄色",
                imgUrl:
                  "//m.360buyimg.com/mobilecms/s750x750_jfs/t1/176117/29/12473/209741/60b4db81E6a624deb/d8e314b95fd2a7fd.jpg!q80.dpg.webp"
              }
            ],
            largeImageMode: true
          },
          {
            k: "版本",
            k_id: "2",
            v: [
              {
                id: "64GB",
                name: "64GB"
              },
              {
                id: "128GB",
                name: "128GB"
              },
              {
                id: "256GB",
                name: "256GB"
              }
            ],
            k_s: "s2",
            count: 2
          }
        ],

        list: [
          // 第1台手机------------------------
          {
            price: 459900, //价格
            s1: "白色",
            s2: "64GB",
            s3: " Apple/苹果 iPhone 11 国行手机 正品保障 官方自营",
            s4: false,
            imgUrl:
              "//m.360buyimg.com/mobilecms/s1265x1265_jfs/t1/181147/16/6648/192505/60b4db17E96972480/b658977c7b38fb68.jpg!q70.dpg.webp",
            stock_num: 120 //库存
          },
          {
            price: 479900, //价格
            s1: "白色",
            s2: "128GB",
            s3: " Apple/苹果 iPhone 11 国行手机 正品保障 官方自营",
            s4: false,
            imgUrl:
              "//m.360buyimg.com/mobilecms/s1265x1265_jfs/t1/181147/16/6648/192505/60b4db17E96972480/b658977c7b38fb68.jpg!q70.dpg.webp",
            stock_num: 120 //库存
          },
          {
            price: 519900, //价格
            s1: "白色",
            s2: "256GB",
            s3: " Apple/苹果 iPhone 11 国行手机 正品保障 官方自营",
            s4: false,
            imgUrl:
              "//m.360buyimg.com/mobilecms/s1265x1265_jfs/t1/181147/16/6648/192505/60b4db17E96972480/b658977c7b38fb68.jpg!q70.dpg.webp",
            stock_num: 120 //库存
          },
          // 第2台手机--------------------------
          {
            price: 459900, //价格
            s1: "黑色",
            s2: "64GB",
            s3: " Apple/苹果 iPhone 11 国行手机 正品保障 官方自营",
            s4: false,
            imgUrl:
              "//m.360buyimg.com/mobilecms/s1265x1265_jfs/t1/148614/3/19332/194556/60b4daf6E6a82e433/b377ed29fe81969d.jpg!q70.dpg.webp",
            stock_num: 320 //库存
          },
          {
            price: 479900, //价格
            s1: "黑色",
            s2: "128GB",
            s3: " Apple/苹果 iPhone 11 国行手机 正品保障 官方自营",
            s4: false,
            imgUrl:
              "//m.360buyimg.com/mobilecms/s1265x1265_jfs/t1/148614/3/19332/194556/60b4daf6E6a82e433/b377ed29fe81969d.jpg!q70.dpg.webp",
            stock_num: 320 //库存
          },
          // 第3台手机--------------------------
          {
            price: 459900, //价格
            s1: "红色",
            s2: "64GB",
            s3: " Apple/苹果 iPhone 11 国行手机 正品保障 官方自营",
            s4: false,
            imgUrl:
              "//img14.360buyimg.com/n4/jfs/t1/178142/29/6740/223672/60b4db50Eaa2760ac/e8329fb598d24e82.jpg",
            stock_num: 145 //库存
          },
          {
            price: 479900, //价格
            s1: "红色",
            s2: "128GB",
            s3: " Apple/苹果 iPhone 11 国行手机 正品保障 官方自营",
            s4: false,
            imgUrl:
              "//img14.360buyimg.com/n4/jfs/t1/178142/29/6740/223672/60b4db50Eaa2760ac/e8329fb598d24e82.jpg",
            stock_num: 145 //库存
          },
          // 第4台手机--------------------------
          {
            price: 459900, //价格
            s1: "紫色",
            s2: "64GB",
            s3: " Apple/苹果 iPhone 11 国行手机 正品保障 官方自营",
            s4: false,
            imgUrl:
              "//img14.360buyimg.com/n4/jfs/t1/129466/10/19818/214901/60b4dbaeEc1be2431/5ab2057eb1162430.jpg",
            stock_num: 45 //库存
          },
          {
            price: 479900, //价格
            s1: "紫色",
            s2: "128GB",
            s3: " Apple/苹果 iPhone 11 国行手机 正品保障 官方自营",
            s4: false,
            imgUrl:
              "//img14.360buyimg.com/n4/jfs/t1/129466/10/19818/214901/60b4dbaeEc1be2431/5ab2057eb1162430.jpg",
            stock_num: 45 //库存
          },
          {
            price: 519900, //价格
            s1: "紫色",
            s2: "256GB",
            s3: " Apple/苹果 iPhone 11 国行手机 正品保障 官方自营",
            s4: false,
            imgUrl:
              "//img14.360buyimg.com/n4/jfs/t1/129466/10/19818/214901/60b4dbaeEc1be2431/5ab2057eb1162430.jpg",
            stock_num: 45 //库存
          },
          // 第5台手机--------------------------
          {
            price: 459900,
            s1: "黄色",
            s2: "64GB",
            s3: " Apple/苹果 iPhone 11 国行手机 正品保障 官方自营",
            s4: false,
            imgUrl:
              "//img14.360buyimg.com/n4/jfs/t1/176117/29/12473/209741/60b4db81E6a624deb/d8e314b95fd2a7fd.jpg",
            stock_num: 40 //库存
          },
          {
            price: 479900,
            s1: "黄色",
            s2: "128GB",
            s3: " Apple/苹果 iPhone 11 国行手机 正品保障 官方自营",
            s4: false,
            imgUrl:
              "//img14.360buyimg.com/n4/jfs/t1/176117/29/12473/209741/60b4db81E6a624deb/d8e314b95fd2a7fd.jpg",
            stock_num: 40 //库存
          },
          {
            price: 519900,
            s1: "黄色",
            s2: "256GB",
            s3: " Apple/苹果 iPhone 11 国行手机 正品保障 官方自营",
            s4: false,
            imgUrl:
              "//img14.360buyimg.com/n4/jfs/t1/176117/29/12473/209741/60b4db81E6a624deb/d8e314b95fd2a7fd.jpg",
            stock_num: 40 //库存
          }
        ],

        price: "4599.00", // 默认价格（单位元）
        stock_num: 1120, // 商品总库存
        collection_id: 2261, // 无规格商品 skuId 取 collection_id，否则取所选 sku 组合对应的 id
        none_sku: false, // 是否无规格商品
        hide_stock: false // 是否隐藏剩余库存
      },

      // 数据结构见下方文档
      goods: {
        // 默认商品 sku 缩略图
        picture:
          "//m.360buyimg.com/mobilecms/s1265x1265_jfs/t1/181147/16/6648/192505/60b4db17E96972480/b658977c7b38fb68.jpg!q70.dpg.webp"
      },
      rd: null
      // empty: []
    };
  },
  methods: {
    playPause() {
      this.$refs.im.style.display = "none";
      this.$refs.im1.style.display = "none";
      var myVideo = document.getElementById("video1");
      if (myVideo.paused) myVideo.play();
      else myVideo.pause();
    },
    s() {
      this.show = !this.show;
    },
    onClickLeft() {
      this.$router.push("index/tabbar1");
    },
    tab4() {
      this.$router.push("index/tabbar4");
    },
    text() {
      this.isshow = !this.isshow;
      this.re = !this.re;
      if (this.te == "收藏") {
        this.te = "已收藏";
        this.$toast({
          message: "已收藏成功",
          position: "top"
        });
      } else {
        this.te = "收藏";
        this.$toast({
          message: "已取消收藏",
          position: "top"
        });
      }
    },
    no() {
      alert("别点了，该模块还没开发呢！！！");
    },
    // vueX===========================================
    onAddCartClicked(cart) {
      // console.log(a1);
      // this.num++;
      // this.empty.push(a1);
      this.$store.commit("addempty", cart);
      if (this.$store.state.empty.length !== 0) {
        this.show = !this.show;
        this.$toast({
          message: "已添加购物车",
          position: "top"
        });
      }
      // console.log(this.$store.state.empty);
    },
    onBuyClicked(b2) {
      console.log(b2);
    }
  },
  updated() {
    // Vue实例更新后执行
    this.num = this.$store.state.empty.length;
  },
  mounted() {
    // Vue实例渲染完成后执行
    // this.re = this.$refs.re;
    this.num = this.$store.state.empty.length;
  }
};
</script>
<style lang="scss" scoped>
@import url("~@/assets/css/indexs/indexs1/indexs1.css");
.active {
  color: #ff5000 !important;
}
.indexs1 {
  background-color: #fff;
}
.activ {
  color: #ff2f2c;
}
.van-goods-action {
  z-index: 100;
}
</style>
